import { set, toggle } from "@/utils/vuex"

export default {
  setDrawer: (state, v) => {
    state.drawer.main = v
    state.drawer.secondary = v
  },
  setMainDrawer: (state, v) => {
    state.drawer.main = v
  },
  setSecondaryDrawer: (state, v) => {
    state.drawer.secondary = v
  },
  setImage: set("image"),
  setColor: set("color"),
  toggleDrawer: toggle("drawer")
}
